/* =====================================================================
   aw-v3-supports.js — le changement de support.

   Les cinq vues sont déjà dans la page, rendues par Liquid : le script ne
   fait que déplacer l'opacité et l'état des onglets. Sans lui, la première
   vue reste affichée et les cinq images restent accessibles.
   ===================================================================== */

(function () {
  'use strict';

  function monte(racine) {
    if (racine.dataset.awv3SupMonte) return;
    racine.dataset.awv3SupMonte = '1';

    var onglets = [].slice.call(racine.querySelectorAll('.awv3-sup__bouton'));
    var vues = [].slice.call(racine.querySelectorAll('.awv3-sup__vue'));
    var nom = racine.querySelector('[data-awv3-sup-nom]');
    var phrase = racine.querySelector('[data-awv3-sup-phrase]');
    if (!onglets.length || !vues.length) return;

    function pose(v) {
      if (v && v.dataset.src) { v.src = v.dataset.src; v.removeAttribute('data-src'); }
    }

    function montre(i, donnerLeFocus) {
      pose(vues[i]);
      onglets.forEach(function (o, k) {
        var actif = k === i;
        o.setAttribute('aria-selected', actif ? 'true' : 'false');
        o.tabIndex = actif ? 0 : -1;
      });
      vues.forEach(function (v, k) {
        var actif = k === i;
        v.classList.toggle('awv3-sup__vue--active', actif);
        /* `hidden` porte le sens pour les technologies d'assistance ;
           le rendu, lui, est tenu par l'opacité, pour que la transition
           ait quelque chose à faire. */
        if (actif) { v.removeAttribute('hidden'); } else { v.setAttribute('hidden', ''); }
      });
      if (nom) nom.textContent = onglets[i].dataset.nom || '';
      if (phrase) phrase.textContent = onglets[i].dataset.phrase || '';
      if (donnerLeFocus) onglets[i].focus();
    }

    onglets.forEach(function (o, i) {
      o.addEventListener('click', function () { montre(i, false); });
    });

    racine.querySelector('.awv3-sup__boutons').addEventListener('keydown', function (e) {
      var i = onglets.indexOf(document.activeElement);
      if (i < 0) return;
      var n = null;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') n = (i + 1) % onglets.length;
      else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') n = (i - 1 + onglets.length) % onglets.length;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = onglets.length - 1;
      if (n === null) return;
      e.preventDefault();
      montre(n, true);
    });

    /* l'image suivante est préchargée dès qu'on en survole le bouton :
       le changement paraît instantané sans rien télécharger d'avance */
    onglets.forEach(function (o, i) {
      o.addEventListener('pointerenter', function () { pose(vues[i]); }, { once: true });
      o.addEventListener('focus', function () { pose(vues[i]); }, { once: true });
    });
  }

  function demarre() {
    [].forEach.call(document.querySelectorAll('[data-awv3="supports-choix"]'), monte);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarre);
  else demarre();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-awv3="supports-choix"]');
    if (r) monte(r);
  });
})();
